import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlignCenterJustify = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.5 6H21.5M3.5 14H21.5M17.5 10H7.5M17.5 18H7.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAlignCenterJustify;
